export default __webpack_public_path__ + "79986d082184be72080cefa161b927c9.png";